svg {
  display: block;
  height: 100%;
  object-fit: contain;
  shape-rendering: geometricprecision;
  width: 100%;
}
